import Logger from '../../functions/logging';

import {
	SET_NAVIGATOR_AUDIO_PERMISSIONS,
	SET_WAITING_FOR_PERMISSION,
} from '../actions/constants';

const INITIAL_STATE = {
	waitingForPermission: false,
	audio: null,
};

export default function (state = INITIAL_STATE, action) {
	Logger.log('navigatorPermissions.js REDUCER()', action.type);

	switch (action.type) {
		case SET_WAITING_FOR_PERMISSION:
			return { ...state, waitingForPermission: action.waiting };
		case SET_NAVIGATOR_AUDIO_PERMISSIONS:
			return { ...state, audio: action.audioPermission };
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/redux/reducers/navigatorPermissions.js